"use client";

import React from "react";
import { useClientSideSplitTreatments } from "@leafly-com/split-next";
import dynamic from "next/dynamic";
import { useSelector } from "react-redux";

import { getIsLoggedIn } from "redux/selectors/user";
import { getSplitKey } from "utils/split/getSplitKey";

const LeafbotButton = dynamic(() => import("./LeafbotButton"));

const Leafbot = () => {
  const isLoggedIn = useSelector(getIsLoggedIn);
  const split = useClientSideSplitTreatments(
    ["leafbotChat_flag", "EL-180_leafbot_test"],
    getSplitKey(),
    {
      attributes: { loggedIn: isLoggedIn },
    },
  );

  if (split.isLoading) {
    return null;
  }

  if (
    split.treatments["leafbotChat_flag"].treatment === "on" ||
    split.treatments["EL-180_leafbot_test"].treatment === "on"
  ) {
    return <LeafbotButton />;
  } else {
    return null;
  }
};

export default Leafbot;
